$(document).ready(function() {

  $('[data-toggle="description"]').on('click', function(e) {
    e.preventDefault();

    const $container = $(this).prev();
    const $preview = $container.find('.description-preview');
    const $full = $container.find('.description-full');
    const isExpanded = $container.attr('data-expanded') === 'true';
    const showMoreText = $(this).attr('data-show-more-translation');
    const showLessText = $(this).attr('data-show-less-translation');

    if (isExpanded) {
      $preview.show();
      $full.hide();
      $(this).text(showMoreText);
      $container.attr('data-expanded', 'false');
    } else {
      $preview.hide();
      $full.show();
      $(this).text(showLessText);
      $container.attr('data-expanded', 'true');
    }
  });

  $(document).on('cart:updated', function(e) {
    
    const price = +e.originalEvent.detail.cart.items_subtotal_price;
    if (price > 0) {
      const points = Math.round(price / 100);
      $('.cb-cart-points-label').removeClass('hidden');
      $('.cb-cart-points').text(points);
    } else {
      $('.cb-cart-points-label').addClass('hidden');
      $('.cb-cart-points').text('0');
    }
  });

  var pdpAtcTextEl = $('.product__info-wrapper .product-form__submit .btn__text');
  var pdpAtcDefaultText = pdpAtcTextEl.attr('data-default-text');
  const pdpAtcSubscribeText = pdpAtcTextEl.attr('data-subscribe-text');
  $(document).on('sealsubs:selling_plan_changed', function(e) {
    const sellingPlanId = e.originalEvent.detail.selling_plan_id;
    sellingPlanId ? pdpAtcTextEl.text(pdpAtcSubscribeText) : pdpAtcTextEl.text(pdpAtcDefaultText);
  })
});